import { isResource } from '@medplum/core'
import type { AuditEvent, Patient, Reference } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export const CAIR_SYNC_SUBTYPE_SYSTEM =
  'https://www.seenhealth.org/fhir/audit-event-subtype'

export const AuditEventSubtype = {
  CAIR_SYNC: 'cair-sync',
} as const
export type AuditEventSubtype =
  (typeof AuditEventSubtype)[keyof typeof AuditEventSubtype]

export class ExtendedAuditEvent extends ExtendedResource<AuditEvent> {
  static readonly RESOURCE_TYPE = 'AuditEvent'

  static isInstance(value: unknown): value is AuditEvent {
    return isResource(value) && isOfType(value, 'AuditEvent')
  }

  static byTypeAndPatient(
    type: AuditEventSubtype,
    patientReference: Reference<Patient>
  ): QueryTypes {
    return {
      entity: patientReference,
      subtype: type,
      _sort: '-date',
      _count: '50',
    }
  }

  get isSuccess(): boolean {
    return this.resource.outcome === '0'
  }

  get recorded(): string | undefined {
    return this.resource.recorded
  }

  get outcomeDesc(): string | undefined {
    return this.resource.outcomeDesc
  }
}
